import React from 'react';
import { Cancel, CheckCircle, Help, Remove } from '@mui/icons-material';
import { MatchScore } from '../types';
import { theme } from '../../../ThemeContext/ThemeObject';

export const SCORE_DISPLAY_CONFIG = {
  [MatchScore.EXCELLENT]: {
    icon: <CheckCircle sx={{ color: theme.palette.success.main }} />,
    text: 'Excellent match',
    color: theme.palette.success.main,
    bgColor: theme.palette.success.light
  },
  [MatchScore.GOOD]: {
    icon: <Remove sx={{ color: '#FFD600' }} />,
    text: 'Good match',
    color: '#795548',
    bgColor: '#FFF9C4'
  },
  [MatchScore.POOR]: {
    icon: <Cancel sx={{ color: theme.palette.error.main }} />,
    text: 'Poor match',
    color: theme.palette.error.main,
    bgColor: theme.palette.error.light
  },
  PENDING: {
    icon: <Help sx={{ color: theme.palette.common.darkGrey }} />,
    text: 'Pending assessment',
    color: theme.palette.common.grey,
    bgColor: theme.palette.common.grey
  }
} as const;
